import { NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';

export type BackofficeDialogSize = 'compact' | 'standard' | 'medium' | 'wide' | 'workspace';

/** Shared shell: centered, bounded body scroll, fixed actions and accessible heading.
 * Supply description=true only when the template contains `${id}-description`.
 * Add beforeDismiss at the caller when an operation must finish before leaving.
 */
export function backofficeDialogOptions(
  id: string,
  size: BackofficeDialogSize = 'standard',
  description = false
): NgbModalOptions {
  return {
    centered: true,
    backdrop: 'static',
    windowClass: `bo-dialog-pilot bo-dialog-pilot--${size}`,
    backdropClass: 'bo-dialog-pilot-backdrop',
    ariaLabelledBy: `${id}-title`,
    ...(description ? { ariaDescribedBy: `${id}-description` } : {}),
  };
}
